import { render } from "./ChampionAbilityDescription.vue?vue&type=template&id=c74e34d0&scoped=true"
import script from "./ChampionAbilityDescription.vue?vue&type=script&lang=ts"
export * from "./ChampionAbilityDescription.vue?vue&type=script&lang=ts"

import "./ChampionAbilityDescription.vue?vue&type=style&index=0&id=c74e34d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c74e34d0"

export default script